import api from 'apis/config/api-service';

interface Supplier {
  id: string | number;
  [key: string]: any;
}

interface SupplierParams {
  [key: string]: any;
}

interface WhatsNumberData {
  id: string | number;
  [key: string]: any;
}

export default {
  getSuppliers: (params?: SupplierParams) => api.get('suppliers', { ...params }),
  getSupplierById: (id: string | number, params?: SupplierParams) => api.get(`suppliers/${id}`, { ...params }),
  updateSupplier: (supplier: Supplier) => api.patch(`suppliers/${supplier.id}`, supplier),
  getSupplierUsers: (id: string | number, params?: SupplierParams) =>
    api.get(`users?filter=supplierId||$eq||${id}&`, params),
  getSupplierAdminUsers: (id: string | number, params?: SupplierParams) => api.get(`users/${id}/staff`, params),
  getSupplierKpi: (supplierId: string | number, params?: SupplierParams) =>
    api.get(`reports/supplier-kpis/${supplierId}`, { ...params }),
  mergeSupplier: (supplierId: string | number, mergedId: string | number) =>
    api.post(`suppliers/merge/${supplierId}/${mergedId}`),
  getWhatsNumbers: (params?: SupplierParams) => api.get(`whatsapp-numbers`, { ...params }),
  updateWhatsNumbers: (data: WhatsNumberData) => api.patch(`whatsapp-numbers/${data.id}`, data),
};
